import { render, staticRenderFns } from "./BatchEditCategories.vue?vue&type=template&id=039da4ae&"
import script from "./BatchEditCategories.vue?vue&type=script&lang=js&"
export * from "./BatchEditCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports